import React, { useState, useContext } from "react";
import config, { getHeaders } from "../config";
import axios from "axios";
import { logCallEvent } from "../analytics/AnalyticsEvent";
const CallContext = React.createContext();

export const CallProvider = ({ children }) => {
  const [callStart, setCallStart] = useState(false);
  const [callLoader,setCallLoader]=useState(false);
  const [noNumAlert,setNoNumAlert]=useState(false);
  const [showModal,setShowModal]=useState(false);
  const uid = localStorage.getItem("uid")
    ? localStorage.getItem("uid")
    : "";
  const localStorageCallsList = localStorage.getItem("callsList")
    ? JSON.parse(localStorage.getItem("callsList"))
    : [];
  const [callsList, setCallsList] = useState(localStorageCallsList);

  const callInfoApi = async (selectedAvatar, number, callingScreen) => {
    console.log("callingScreen is::", callingScreen);
    const vShortCode=localStorage.getItem("voiceShortCode")
    ? JSON.parse(localStorage.getItem("voiceShortCode"))
    : "*1717";
    const aShortCode=localStorage.getItem("ambienceShortCode")
    ? JSON.parse(localStorage.getItem("ambienceShortCode"))
    : "*1717";
    const callShortCode=selectedAvatar?.type==="voice"?vShortCode:aShortCode;
    //logging the GA4 event for callInfo api request
   
    logCallEvent(
      {
        screen: `${callingScreen}`,
        event: "callInfo_api_request",
      },
      {
        // title: "request",
        userId: uid ? uid : "",
        others: {
          type: selectedAvatar.type,
          uid: selectedAvatar.uid,
        },
      }
    );
    setCallStart(true);
    setCallLoader(true);
    console.log("selectedAvatar is:::", selectedAvatar);
    const url = `${config.get("base")}${config.get("callInfo")}`;
    const postData = {
      msisdn: localStorage.getItem('msisdn')?localStorage.getItem('msisdn'):"",
      bparty:number,
      voiceid: selectedAvatar?.short_code,
      channel: "wap",
      type: selectedAvatar?.type,
    };
    const headers= {  ...getHeaders(),
        camp : localStorage.getItem("campId") || sessionStorage.getItem("campId"),
        rcid : localStorage.getItem("rcid") || sessionStorage.getItem("rcid")};
    await axios
      .post(url,  postData , {headers:headers})
      .then((result) => {
        console.log("callInfo api :::", result);
        //logging the GA4 event for callInfo api response
        logCallEvent(
          {
            screen: `${callingScreen}`,
            event: "callInfo_api_response",
          },
          {
            // title: "response",
            status: result?.data?.status,
            userId: uid ? uid : "NA",
            others: {
              type: selectedAvatar.type,
              uid: selectedAvatar.uid,
            },
          }
        );
        document.location.href = "tel:" + callShortCode + number;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => 
      {
        setCallStart(false)
        setCallLoader(false)
      });
  };

  return (
    <CallContext.Provider
      value={{ callStart, setCallStart, callInfoApi, callsList, setCallsList,callLoader,setCallLoader,noNumAlert,setNoNumAlert
      ,showModal,setShowModal }}
    >
      {children}
    </CallContext.Provider>
  );
};
export const useCallContext = () => {
  return useContext(CallContext);
};
